export default __webpack_public_path__ + "static/media/printlogo.4252b78d.png";